// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__W74bO","savePackageButton":"ClientWallet_savePackageButton__GjoiR"};